var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
    _c(
      "div",
      {
        directives: [{ name: "adrag", rawName: "v-adrag" }],
        ref: "myDiv",
        class: [_vm.className, "wind-farm-modal-wrapper"],
        style: {
          width: _vm.width
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _vm.leftArrow
            ? _c(
                "div",
                {
                  staticClass: "icon-wrapper",
                  on: { click: _vm.handleLeftClick }
                },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              )
            : _vm._e(),
          _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
          _c(
            "div",
            { staticClass: "close-btn", on: { click: _vm.handleClose } },
            [_c("i", { staticClass: "el-dialog__close el-icon el-icon-close" })]
          )
        ]),
        _c(
          "div",
          {
            staticClass: "content",
            style: {
              height: _vm.height
            }
          },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }